import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { MdOutlineFolderOff } from 'react-icons/md';

const EmptyState = ({
  title = 'No data available',
  icon: Icon = MdOutlineFolderOff,
  iconSize = 54,
  children = null,
}: {
  title?: string;
  icon?: (props: { size: number; color: string }) => ReactNode;
  iconSize?: number;
  children?: ReactNode;
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      height: '100%',
    }}
  >
    <Box
      sx={(theme) => ({
        margin: theme.spacing(1.5, 0),
        color: theme.palette.grey[400],
      })}
    >
      <Icon size={iconSize} color="currentColor" />
    </Box>
    <Typography
      sx={{
        color: 'grey.600',
        fontSize: '1rem',
        fontWeight: 500,
      }}
    >
      {title}
    </Typography>
    {children}
  </Box>
);

export default EmptyState;
